export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    data-tags="keyboard_arrow_left"
  >
    <g fill="currentColor" transform="scale(0.0234375 0.0234375)">
      <path d="M658 708l-60 60-256-256 256-256 60 60-196 196z" />
    </g>
  </svg>
);
